// VRP mode switching utilities
import { useState, useCallback, useEffect, useRef } from 'react';

// Mode constants
export const MODES = ['Setup Path Points', 'Custom Path', 'Auto Find Path', 'Comparison Mode'];

// Setup mode submodes
export const SETUP_SUBMODES = {
  MAP: 'Map Point Marking',
  MANUAL: 'Manual Input'
};


export const useModeSwitching = () => {
  const [currentMode, setCurrentMode] = useState(MODES[0]);
  const [setupSubmode, setSetupSubmode] = useState(SETUP_SUBMODES.MAP);
  const currentModeRef = useRef(currentMode);
  
  // Update mode reference
  useEffect(() => {
    currentModeRef.current = currentMode;
  }, [currentMode]);
  
  // Submode switching
  const handleSubmodeSwitching = useCallback((submode) => {
    setSetupSubmode(submode);
  }, []);
  
  return {
    currentMode, 
    setCurrentMode,
    currentModeRef,
    setupSubmode, 
    setSetupSubmode,
    handleSubmodeSwitching
  };
};


export const getActiveModeName = (currentMode) => {
  return currentMode || MODES[0];
};


export const isAutoMode = (mode) => {
  return mode === MODES[2];
};


export const isCustomMode = (mode) => {
  return mode === MODES[1];
};


export const isSetupMode = (mode) => {
  return mode === MODES[0];
};


export const isCompareMode = (mode) => {
  return mode === MODES[3];
}; 